// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"453":"component---src-pages-404-tsx","707":"component---src-localization-en-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"453":"642f456cb151e64bd4a0","577":"0e1af612449efdbf5c69","707":"7d0e84d1aa6daa1b5a29"}[chunkId] + ".js";
};